// Map styles to hide POI but keep landscape colors and show house numbers/parcels
// UPDATE: Update styles if required, currently nothing needs to be hidden
export const MAP_STYLES = [];
